export enum PublicLinkActionType {
    UPDATE_CONTACT = "UPDATE_CONTACT",
    UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
    SIGN_CONSENT = "SIGN_CONSENT",
    VIEW_P_CONSENT = "VIEW_P_CONSENT",
}



export class PublicAction {
    id: number;
    contact_id: number;

    secret: string;
    action_type: PublicLinkActionType;
    meta_data?: string;
    is_used?: boolean;
    created_at?: string;
    expires_at?: string;
    filled_at?: string;

    constructor(init?: Partial<PublicAction>) {
      Object.assign(this, init);
    }

    static defaultEmpty(): PublicAction {
      return new PublicAction({
        id: 0,
        contact_id: 0,

        secret: "",
        action_type: PublicLinkActionType.UPDATE_CONTACT,
        meta_data: "",
        is_used: false,
      });
    }
  }

  export class CreatePublicAction {
    contact_id: number;
    action_type: string;
    meta_data?: string | null;

    constructor(init?: Partial<CreatePublicAction>) {
      Object.assign(this, init);
    }

    static defaultEmpty(): CreatePublicAction {
      return new CreatePublicAction({
        contact_id: 0,
        action_type: PublicLinkActionType.UPDATE_CONTACT,
        meta_data: null,
      });
    }
  }
  
